// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2r-q";
export var animationRelative = "_2r-p";
export var backdropBlur = "_2r-0";
export var detailLabelCell = "_2r-12";
export var detailTable = "_2r-11";
export var detailValueCell = "_2r-13";
export var docIconBox = "_2r-1d";
export var docIconBoxMd = "_2r-1f";
export var docIconBoxSm = "_2r-1e";
export var docTypeRow = "_2r-16";
export var docTypeRowInner = "_2r-17";
export var dropdownMatchDatePicker = "_2r-3";
export var evidenceCardContent = "_2r-1c";
export var fileUploadSpin = "_2r-j";
export var gorgiasOpenButton = "_2r-15 _2r-d";
export var gorgiasTicketCard = "_2r-14";
export var heroModalFooterButton = "_2r-18";
export var hiddenContainer = "_2r-o";
export var iconPrimary = "_2r-1g";
export var iconSecondary = "_2r-1h";
export var iconTertiary = "_2r-1i";
export var integrationCard = "_2r-1";
export var integrationLogoBox = "_2r-2";
export var mainColumnSticky = "_2r-1b";
export var maxWidthContainer = "_2r-19";
export var modalContentBody = "_2r-a";
export var modalHeaderImage = "_2r-5";
export var modalImageLabel = "_2r-7";
export var modalImageOverlay = "_2r-6";
export var modalImageSubtitle = "_2r-9";
export var modalImageTitle = "_2r-8";
export var modalImageWrapper = "_2r-4";
export var modalStickyFooter = "_2r-b";
export var removeButton = "_2r-e";
export var sidebarColumn = "_2r-1a";
export var spinner = "_2r-i";
export var timelineLine = "_2r-y";
export var timelineLineBlack = "_2r-10 _2r-y";
export var timelineLineGray = "_2r-z _2r-y";
export var timelineLineHeight = "_2r-x";
export var tlDotActivate = "_2r-u";
export var tlDotActivateAnim = "_2r-t";
export var tlDotHide = "_2r-s";
export var tlDotHideAnim = "_2r-r";
export var tlLineActivate = "_2r-w";
export var tlLineActivateAnim = "_2r-v";
export var uploadHint = "_2r-n";
export var uploadIconBox = "_2r-k";
export var uploadLabel = "_2r-m";
export var uploadText = "_2r-l";
export var uploadZone = "_2r-f";
export var uploadZoneCursorDefault = "_2r-h";
export var uploadZoneCursorPointer = "_2r-g";
export var uploadedFileRow = "_2r-c";
export var viewButton = "_2r-d";